module.exports = __webpack_public_path__ + "static/sentiment_clf-f1fe7f77413c1c2b61eed951338c1704.png";